import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-enclosure',
  templateUrl: './sample-enclosure.component.html',
  styleUrls: ['./sample-enclosure.component.scss']
})
export class SampleEnclosureComponent implements OnInit {

  @Input() block: any;
  @Input() column: any;
  public dataFile: any[] = [];
  public domainWebsite = environment.urlApi;

  constructor() { }

  ngOnInit(): void {
    this.retrieveHrefAndSize();
  }
  
  private retrieveHrefAndSize(): void {
    if (this.block && this.block.set_allegati && this.block.set_allegati.length) {
        const result = [];
        const fileExtensions = ['pdf', 'txt', 'doc', 'xls', 'ppt', 'pps', 'odt', 'ods', 'odp', 'xlsx', 'docx', 'pptx', 'zip', 'rar', 'csv', 'msword'];

        for (const allegato of this.block.set_allegati) {
            const title = allegato.titolo || allegato.allegato.match(/<a [^>]*>([^<]+)<\/a>/)[1];
            const description = allegato.descrizione;
            let fileAttachment = allegato.file_allegato ? allegato.file_allegato : allegato.allegato;    
            let link = '';

            const matches = fileAttachment.match(/<a href="([^"]+)" type="application\/([^"]+)">/);
            if (matches) {
                const href = matches[1];
                link = this.domainWebsite + href;
                fileAttachment = fileAttachment.replace(href, this.domainWebsite + href);
            }

            result.push({
                title,
                description,
                fileAttachment,
                link,
            });
        }

        this.dataFile = result;
    }
}


}
